import {PROPERTY_SELECTOR_SIGIL} from '../constants';

export default function createAddSelectablePropertyMapping(resolvedMappings) {
	return function (consumerDetail, resolvedValue) {
		const {consumerId, consumerPropName} = consumerDetail;
		const consumerKey = `${consumerId}${PROPERTY_SELECTOR_SIGIL}${consumerPropName}`;
		resolvedMappings.set(consumerKey, resolvedValue);
	};
}
